function buildMarquee() {
  var bars = document.querySelectorAll(".announce");
  for (var i = 0; i < bars.length; i++) {
    var bar = bars[i];
    if (bar.getAttribute("data-marquee")) continue;
    var inner = bar.innerHTML.trim();
    if (!inner) continue;
    var unit = '<span class="announce-unit">' + inner + "</span>";
    bar.innerHTML = '<span class="announce-track">' + unit + unit + "</span>";
    bar.classList.add("marquee-on");
    bar.setAttribute("data-marquee", "1");

    console.log("Marquee built");
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", buildMarquee);
  console.log("DOM not yet loaded");
} else {
  buildMarquee();
  console.log("DOM fully loaded and parsed");
}